












import IMenu from './menu'
import ViewBase from '@/utils/ViewBase'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    IMenu
  }
})
export default class Main extends ViewBase {
  @Prop( {
      type: Boolean,
      required: false,
      default: false
    }) collapsible: any
  @Prop( {
      type: Boolean,
      required: false,
      default: false
    }) collapsed: any
  @Prop( {
      type: Array,
      required: true
    }) menuData: any
  @Prop( {
      type: String,
      required: false,
      default: 'dark'
    }) theme: any

  get isMobile() {
    return this.$store.state.setting.isMobile
  }

  get systemName() {
    return this.$store.state.setting.systemName
  }

  onSelect(obj: any) {
    this.$emit('menuSelect', obj)
  }
}
